import { OnboardingRequirement } from 'generated/types'

import { FlowRoute } from '../../types'

interface StateInput {
  missingRequirements: OnboardingRequirement[]
}

export const plaidSuccessSkip = ({ isAlreadyLinked }) => {
  if (isAlreadyLinked) {
    return FlowRoute.PricingInterstitial
  }
  return FlowRoute.BankLinkSuccess
}

export const bankLinkSuccessContinue = (
  { roundUpsEnabled, isEligibleRoundUps, isSecondChanceBankLink },
  { visitedPages },
) => {
  if (isSecondChanceBankLink) {
    return isEligibleRoundUps ? FlowRoute.RoundUpsSetup : FlowRoute.RecurringInvestment
  } else if (visitedPages.includes(FlowRoute.RecurringInvestment)) {
    return roundUpsEnabled ? FlowRoute.RoundUpsInterstitial : FlowRoute.RecurringInvestment
  } else if (visitedPages.includes(FlowRoute.OneTimeInvestment)) {
    return roundUpsEnabled ? FlowRoute.RoundUpsInterstitial : FlowRoute.OneTimeInvestment
  }

  return FlowRoute.PricingInterstitial
}

export const addressSuggestionContinue = () => {
  return FlowRoute.AddressPreview
}

export const mapRegistrationRequirementsToRoute = ({
  missingRequirements,
}: StateInput): FlowRoute => {
  if (
    missingRequirements.includes(OnboardingRequirement.FIRST_NAME) ||
    missingRequirements.includes(OnboardingRequirement.LAST_NAME)
  ) {
    return FlowRoute.PersonalInfo
  }

  if (missingRequirements.includes(OnboardingRequirement.PHONE_NUMBER)) {
    return FlowRoute.PhoneNumber
  }

  if (missingRequirements.includes(OnboardingRequirement.SUBSCRIPTION)) {
    return FlowRoute.PricingInterstitial
  }

  return FlowRoute.Funding
}
